// JoinFormPopup.js
import React, { useState } from "react";
import "./joinhere.css";
import { fetchJoinUserApi } from "../../api/api";

const JoinFormPopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    tools: [],
    findUsefull: "",
    improved: "",
    type: 2,
  });
  const [emailError, setEmailError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email.trim()) {
      setEmailError("Email is required.");
      return;
    } else if (!validateEmail(formData.email)) {
      setEmailError("Please enter a valid email address.");
      return;
    } else {
      setEmailError("");
    }

    const submittedData = {
      ...formData,
      tools: formData.tools.join(", "),
    };


    try {
        const response = await fetchJoinUserApi(submittedData);
        if (response?.message) {
          setSuccessMessage(response.message);
        } else {
          setSuccessMessage("Submitted successfully.");
        }
    
        setFormData({
          tools: [],
          findUsefull: "",
          improved: "",
          email: "",
          type: 1,
          name: ""
        });
    
        setTimeout(() => {
          setSuccessMessage("");
          onClose();
        }, 1000);
      } catch (err) {
        setEmailError("Something went wrong. Please try again.");
      }
  };

  return (
    <div className="AF-popupOverlay">
      <div className="AF-popup-join">
        <div className="AF-header-join">
           <h1>Join Best Bets</h1>
          <button className="AF-closeBtnLeft-join" onClick={onClose}>×</button>
        </div>
        {successMessage && <p className="success-msg-join">{successMessage}</p>}
        <form onSubmit={handleSubmit}>
          <label className="form-label-join">Name</label>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
          />

          <label className="form-label-join">Email</label>
          <input
            type="text"
            name="email"
            placeholder="Your@example.com"
            value={formData.email}
            onChange={handleChange}
          />
          {emailError && <p className="email-error-msg">{emailError}</p>}

          <div className="AF-buttonGroup">
            {/* <button type="button" onClick={onClose} className="AF-closeBtn">
              Close
            </button> */}
            <button type="submit" className="AF-submitBtn-join">
              Join Now
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JoinFormPopup;
